import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced:true,
  state: {
    token:'',
    fileStatus:{
      start:'已开标',
      end:'已结束',
      noStart:'等待开标'
    },
    myTbListStatus:{
      submit:'提交成功',
      fail:'投标失败',
      success:'投标成功'
    },
    userStatus:{
      success:'审核通过',
      examine:'审核中'
    },

  },
  getters: {
    getToken:(state) => {
      return state.token
    },
    getFileStatus:(state) => {
      return state.fileStatus
    },
    getMyTbListStatus:(state) => {
      return state.myTbListStatus
    },
    getUserStatus:(state) => {
      return state.userStatus
    }
  },
  mutations: {
    UPDATE_TOKEN(state,token){
      state.token = token
    },
  },
  actions: {
  },
  modules: {
  }
})
